/** Small display helpers shared by the Finances cost cards and the expense rows. */

export function formatDayLabel(iso: string): string {
  const parts = iso.split("-").map(Number);
  const [y, m, d] = parts;
  if (parts.length !== 3 || !y || !m || !d) return iso;
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
}

export function euro(raw: string | undefined): string {
  if (raw === undefined) return "—";
  const n = Number(raw);
  if (!Number.isFinite(n)) return raw;
  return `€${n.toFixed(2)}`;
}
